interface LogoProps {
  /** Overall height of the mark in px; the wordmark scales from it. */
  size?: number;
  /** Light wordmark for dark backgrounds (header), dark for light backgrounds. */
  variant?: 'light' | 'dark';
  /** Hide the "AI Supe" wordmark and show only the mark (tight spaces). */
  markOnly?: boolean;
}

/**
 * AI Supe brand logo: a gradient badge with an AI "spark" glyph plus the
 * wordmark. Fully self-contained SVG (no external asset) so it renders anywhere
 * and never causes the header overflow the old long text label did.
 */
export function Logo({ size = 30, variant = 'light', markOnly = false }: LogoProps) {
  const textColor = variant === 'light' ? '#ffffff' : '#0f172a';
  const gradientId = `ai-supe-grad-${variant}`;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10, lineHeight: 1 }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        role="img"
        aria-label="AI Supe"
      >
        <defs>
          <linearGradient
            id={gradientId}
            x1="0"
            y1="0"
            x2="32"
            y2="32"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#6366F1" />
            <stop offset="1" stopColor="#A855F7" />
          </linearGradient>
        </defs>
        <rect width="32" height="32" rx="9" fill={`url(#${gradientId})`} />
        {/* Four-point "AI spark" */}
        <path
          d="M16 5c.9 6.3 4.7 10.1 11 11-6.3.9-10.1 4.7-11 11-.9-6.3-4.7-10.1-11-11 6.3-.9 10.1-4.7 11-11Z"
          fill="#ffffff"
        />
        {/* Small accent spark */}
        <path
          d="M24.5 7c.3 1.9 1.4 3 3.3 3.3-1.9.3-3 1.4-3.3 3.3-.3-1.9-1.4-3-3.3-3.3 1.9-.3 3-1.4 3.3-3.3Z"
          fill="#ffffff"
          opacity="0.85"
        />
      </svg>
      {markOnly ? null : (
        <span
          style={{
            fontSize: Math.round(size * 0.6),
            fontWeight: 700,
            letterSpacing: '-0.02em',
            color: textColor,
            whiteSpace: 'nowrap',
          }}
        >
          AI Supe
        </span>
      )}
    </span>
  );
}
